import axiosWithToken from "axiosWithToken";

const API_URL = process.env.REACT_APP_API_URL;

export const getAccountDetails = async () => {
  try {
    const response = await axiosWithToken.get(`${API_URL}api/auth/user`);
    return response.data;
  } catch (error) {
    console.error("Error getting account details:", error);
    throw error;
  }
};
